import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Preloader from '../components/Preloader';
import { API_ENDPOINTS } from '../config/api';

import axios from 'axios';
const url = API_ENDPOINTS.COUNTRIES;

const Countries = (props) => {
  const { cached, updateCache } = props;
  const [tableMessage, setTableMessage] = useState('Loading data...');
  const [formData, setFormData] = useState({});
  const [disabled, setDisabled] = useState(false);
  const [countries, setCountries] = useState(cached.countries);
  const [updated, setUpdated] = useState({
    countries: false,
  });

  useEffect(() => {
    if ( cached.countries ) {
      setCountries(cached.countries.sort((a, b) => (a.name > b.name) ? 1 : -1));
    } else if (!updated.countries) {
      setUpdated({...updated, countries: true});
      makeRequest('GET');
    }
  }, [JSON.stringify(cached?.countries)]);

  const onChangeHandler = (e) => {
    const { name, value, type, checked } = e.currentTarget;
    const val = type === 'checkbox' ? checked : type === 'select' ? e.target.value : value;

    setFormData({
      ...formData,
      [name]: val,
    });
  }

  const onSubmitHandler = () => {
    if ( formData.id >= 0 ) {
      makeRequest('PUT');
    } else {
      makeRequest('POST');
    }
  }

  const clearFormHandler = () => {
    setFormData({});
  }

  const onDeleteHandler = (id) => {
    if (window.confirm('Do you really want to delete it?')) {
      makeRequest('DELETE', id);
    }
  }

  const makeRequest = (method, id) => {
    setDisabled(true);

    let requestUrl = url;
    let message = method === 'POST' ? 'Item is added' : 
                  method === 'PUT' ? 'Item is updated' :
                  method === 'DELETE' ? 'Item is deleted' : null;

    const requestData = {
      method: method,
      signal: AbortSignal.timeout(20000)
    };

    if ( method === 'POST' || method === 'PUT' ) {
      requestData.data = { ...formData };
    }

    if ( method === 'DELETE' || method === 'PUT' ) {
      const requestId = id ? id : formData.id;

      requestUrl += `/${requestId}`;
    }

    axios(requestUrl, requestData).then((response) => {
      clearFormHandler();

      if ( method === 'GET' ) {
        updateCache(response.data);
        setDisabled(false);
      } else {
        makeRequest('GET');
      }

      if ( message ) {
        toast.success(message, {
          position: 'top-right'
        });
      }
    }).catch( (error) => {
      let err = 'Error: ';

      if (error.response) {
        err += error.response.data.errors;
      } else if (error.request) {
        err += 'No response!';
      } else {
        err += error.message;
      }

      setTableMessage(err);

      toast.error(err, {
        position: 'top-right'
      });
      
      setDisabled(false);
    });
  }

  const updating = typeof countries === 'undefined' ? true : false;

  return (
    <div style={{minHeight: 200}} className="container-fluid position-relative">
      { updating ? <Preloader /> : (
        <React.Fragment>
          <h2 className="mt-5">Countries</h2>

          <div className="mt-5">
            <div className="form-group row">
              <div className="col-3 form-group">
                <label className="form-label">Country Code</label>
                <input
                  type="text"
                  className="form-control"
                  disabled={disabled || updating}
                  placeholder="Country code"
                  name="countrycode"
                  onChange={(e) => onChangeHandler(e)}
                  value={formData.countrycode || ''}
                />
              </div>
              <div className="col-9 form-group">
                <label className="form-label">Country</label>
                <input 
                  type="text" 
                  className="form-control" 
                  disabled={disabled || updating}
                  placeholder="Country" 
                  name="name"
                  onChange={(e) => onChangeHandler(e)} 
                  value={formData.name || ''} 
                />
              </div>
            </div>

            <button disabled={disabled || updating} className="btn btn-primary me-2" onClick={() => onSubmitHandler()}>{formData.id >= 0 ? 'Update' : 'Add'}</button>
            <button disabled={disabled || updating} className="btn btn-secondary" onClick={() => clearFormHandler()}>Clear</button>
          </div>

          <table className="table table-hover mt-5">
            <thead className="thead-dark">
              <tr>
                <th scope="col">#</th>
                <th scope="col">Code</th>
                <th style={{width:'100%'}} scope="col">Name</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              { countries ? countries.map((item, index) => {
                return (
                  <tr key={`country-${item.id}`}>
                    <th style={{whiteSpace: 'nowrap'}} scope="row">{index+1}</th>
                    <td style={{whiteSpace: 'nowrap'}}>{item.countrycode}</td>
                    <td>{item.name}</td>
                    <td style={{whiteSpace: 'nowrap'}}>
                      <button className="btn btn-danger me-1" onClick={() => onDeleteHandler(item.id)}>Delete</button>
                      <button className="btn btn-primary ms-1" onClick={() => {
                        setFormData({ ...item });
                        window.scrollTo(0, 0);
                      }}>Edit</button>
                    </td>
                </tr>
                );
              }) : <tr><td style={{textAlign: 'center', padding: 32}} colSpan="4">{tableMessage}</td></tr> }
            </tbody>
          </table>
        </React.Fragment>
      )}
    </div>
  );
}

export default Countries;
